<!-- 我的消息 -->
<template>
    <div class="el-myNews">
        <el-row class="page_content">
            <h1 class="head_title">我的消息</h1>
            <el-row style="text-align: right;margin-bottom:20px;">
                <el-button type="primary" @click="onSubmit" :loading="submitBut">一键标记已读</el-button>
            </el-row>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="messageTitle"
                    header-align="center"
                    align="center"
                    label="消息标题">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="primary" @click="getMyMessageInfo(scope.$index)">
                        <el-row v-html="scope.row.messageTitle"></el-row>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column
                prop="messageAddTime"
                header-align="center"
                align="center"
                label="发布时间">
                </el-table-column>
                <el-table-column
                prop="messageAcceptState"
                header-align="center"
                align="center"
                label="状态"
                width="180">
                <template slot-scope="scope">
                    <span :class="scope.row.messageAcceptState === 1?'':'wd'">{{scope.row.messageAcceptState == 1?"已读":"未读"}}</span>
                </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: center;bottom: 0;width: 96%;margin: 20px;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1"
                    :page-size="limit"
                    :hide-on-single-page="true"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog
            :title="$messageType(dialogInfo.messageType)"
            :visible.sync="dialogVisible"
            width="1000px"
            >
            <h2 style="text-align: center;margin-top: -10px;" v-html="dialogInfo.messageTitle"></h2>
            <div v-for="(item,index) in dialogInfo.courseResourceList" :key="index+'ResourceList'">
                附件下载：<el-link type="primary" :href="$isHttp(item.courseResourceUrl)" target="_blank">{{item.courseResourceName}}</el-link>
            </div>
            <p style="font-size: 18px;" v-html="dialogInfo.messageConcat"></p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
  name: "MyNews",
  data() {
    return {
      tableData: [],
      dialogInfo:{},
      dialogVisible: false,
      submitBut:false,
      currentPage1: 1,
      total: 0,
      limit:10,
      page:1
    };
  },
  created() {
    this.getMyMessageList();
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getMyMessageList();
    },
    onSubmit(){
      this.submitBut = true;
      this.$store.dispatch("user/setAllAcceptState",{messageAcceptIdPlural:"all"}).then((ret) => {
        this.submitBut = false;
        this.$message({
           message: ret.msg,
           type: ret.code == 0?'success':"warning"
        });
        if(ret.code == 0){
          this.getMyMessageList();
        }
      }).catch((err) => {
        this.submitBut = false;
      });
    },
    getMyMessageList(){ //获取消息列表
      this.$store.dispatch("user/getMyMessageList",{limit:this.limit,page:this.page})
      .then((ret) => {
        if(ret.code == 0){
          this.tableData = ret.data;
          this.total = ret.count;
        }else{
          this.$message({
             message: ret.msg,
             type: ret.code == 0?'success':"warning"
          });
        }
      });
    },
    getMyMessageInfo(index){ //获取消息详情
      this.$store.dispatch("user/getMyMessageInfo",{messageId:this.tableData[index].messageId})
      .then((ret) => {
        if(ret.code == 0){
          this.dialogVisible = true;
          this.dialogInfo = ret.data;
          this.tableData[index].messageAcceptState = 1;
        }else{
          this.$message({
             message: ret.msg,
             type: "warning"
          });
        }
      });
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-myNews{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyNews.vue